"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TrackingHeadScript = function (_a) {
    var id = _a.id, _b = _a.disable, disable = _b === void 0 ? false : _b;
    return (react_1.default.createElement(react_1.default.Fragment, null, id && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("script", { async: true, src: "https://www.googletagmanager.com/gtag/js?id=" + id }),
        react_1.default.createElement("script", { async: true, dangerouslySetInnerHTML: {
                __html: "\n              window.dataLayer = window.dataLayer || [];\n              window['ga-disable-" + id + "'] = " + disable.toString() + ";\n\n              function gtag() { dataLayer.push(arguments); }\n              gtag('js', new Date());\n              gtag('config', '" + id + "', { page_path: window.location.pathname });\n            ",
            } })))));
};
exports.default = TrackingHeadScript;
//# sourceMappingURL=TrackingHeadScript.js.map